import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { t } from 'translation'
import history from 'utils/appHistory'

import ClockIcon from 'assets/clock.png'
import GearIcon from 'assets/gear.png'
import InviteIcon from 'assets/invite-patient.png'
import BackIcon from 'assets/back-icon.png'
import StatIcon from 'assets/stat.png'
// import SearchIcon from 'assets/search.png'

const ControlList = ({
  isPro,
  toggleInviteHandler,
  toggleSettingsHandler,
  toggleAlarmHandler,
  awakening,
  isDoctor,
  attachBackBtnRef,
  recommander,
}) => {
  return (
    <ul className={`controls_list position_mod`}>
      {awakening && (
        <ControlListItem
          alt={t('settings.BACK')}
          image={BackIcon}
          modClass="clock_mod"
          clickHandler={() =>
            isDoctor ? history.push('/welcome-doctor') : history.go('-1')
          }
          attachBackBtnRef={attachBackBtnRef}
        />
      )}
      {/* <li className="controls_list_item offset_mod" /> */}
      {/* {isPro && recommander && (
        <li className="controls_list_item offset_mod">
          <button className="controls_list_link" onClick={() => toggleInviteHandler()}>
            {t('pain.INVITE_PATIENT')}
          </button>
        </li>
      )}
      {isPro && !recommander && (
        <ControlListItem
          alt={t('settings.INVITE_PATIENT')}
          image={InviteIcon}
          modClass="clock_mod"
          clickHandler={() => toggleInviteHandler()}
        />
      )} */}

      {window?.cordova && awakening && isDoctor && !recommander && (
        <ControlListItem
          alt={t('settings.ALARM')}
          image={StatIcon}
          modClass="clock_mod"
          clickHandler={() => (window.location = 'https://admin.sound.care')}
        />
      )}

      {window?.cordova && awakening && !isDoctor && !recommander && (
        <ControlListItem
          alt={t('settings.ALARM')}
          image={ClockIcon}
          modClass="clock_mod"
          clickHandler={() => toggleAlarmHandler()}
        />
      )}

      <ControlListItem
        alt={t('settings.SETTINGS')}
        image={GearIcon}
        clickHandler={() => toggleSettingsHandler()}
        modClass="gear_mod"
      />
      {/* <ControlListItem
      alt={'search'}
      image={SearchIcon}
      href={'/a2_search'}
      modClass={'search_mod'}
    /> */}
    </ul>
  )
}

const mapStateToProps = ({ auth: { isDoctor, attributes, isOnline, isPro } }) => ({
  isPro,
  awakening: !!attributes?.permissions?.indications?.awakening,
  isOnline,
  isDoctor,
})

export default connect(mapStateToProps)(ControlList)

ControlList.propTypes = {
  awakening: PropTypes.bool.isRequired,
  isPro: PropTypes.bool.isRequired,
  toggleAlarmHandler: PropTypes.func.isRequired,
  toggleInviteHandler: PropTypes.func.isRequired,
  toggleSettingsHandler: PropTypes.func.isRequired,
}

const ControlListItem = ({ alt, image, modClass, clickHandler, attachBackBtnRef }) => (
  <li className="controls_list_item">
    <button
      ref={alt === t('settings.BACK') ? attachBackBtnRef : null}
      className="controls_btn"
      onClick={clickHandler}
    >
      <div className={`controls_btn_w_icon ${modClass}`}>
        <img className="controls_btn_icon" src={image} alt={alt} />
      </div>
    </button>
    <span className="close_btn controls_mod" />
  </li>
)
